import { Reveal } from "../lib/reveal";
import { useLang } from "../i18n/LanguageContext";

const proofs = [
  {
    metric: "15",
    label: "Municipal corporations",
    quote: "Deployed and operating across municipal landfill sites in India.",
  },
  {
    metric: "Days",
    label: "To visible odour relief",
    quote: "Pilots demonstrate measurable odour reduction before full deployment.",
  },
  {
    metric: "Indigenous",
    label: "Microbial ecosystem",
    quote: "A locally-developed consortium — not an imported chemical formulation.",
  },
];

export const Proof = () => {
  const { t } = useLang();
  return (
    <section id="proof" data-testid="proof-section" className="py-24 md:py-32 bg-sand">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14">
          <Reveal className="flex items-center gap-3 mb-6">
            <span className="text-xs tracking-[0.22em] uppercase font-semibold text-terracotta">{t("Proof", "प्रमाण")}</span>
          </Reveal>
          <Reveal>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-ink">
              {t("Credibility, earned in the field.", "विश्वसनीयता, मैदान में अर्जित।")}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-slate">
              {t(
                "We lead with pilots and case studies — experience measurable change before you commit to full deployment.",
                "हम पायलट और केस स्टडी से शुरुआत करते हैं — पूर्ण तैनाती से पहले मापने योग्य बदलाव का अनुभव करें।"
              )}
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {proofs.map((p, i) => (
            <Reveal key={p.label} delay={i * 0.1}>
              <div className="h-full bg-bone rounded-3xl border border-stone/20 p-9 flex flex-col">
                <div className="font-serif text-6xl md:text-7xl text-moss leading-none">{p.metric}</div>
                <div className="text-xs tracking-[0.16em] uppercase text-stone mt-4 mb-6">{p.label}</div>
                <p className="text-base leading-relaxed text-slate mt-auto">{p.quote}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
